import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import * as moment from 'moment';
import { ngStorage } from 'ngstorage';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IRetailerRootScope } from '../../../core/models';
import { MenuService } from '../../menu.service';
import { IMenuListItem } from '../../models';

export interface IFakeMenu {
    data: IMenuListItem;
    image: string;
}

class MenusController extends ViewportController {
    public static $inject = [
        '$rootScope',
        '$localStorage',
        '$scope',
        '$stateParams',
        'menuService',
        'definitionsService',
        'notificationService'
    ];
    public fakeMenu: IFakeMenu[] = [
        {
            data: {
                ID: 0,
                Name: 'Breakfast menu',
                StartTime: '9',
                EndTime: '12',
                StartDate: new Date(2019, 8, 20),
                EndDate: null,
                DaysOfWeek: 62,
                ImageID: null,
                DisplayInApp: false,
                CreateDateUTC: new Date(2019, 8, 20),
                Places: [
                    {
                        ID: null,
                        Name: 'Honeyland Rivers',
                        Town: '...',
                        PostCode: '',
                        AddressLine1: '155 Victoria street',
                        AddressLine2: ''
                    }
                ],
                FoodPreferences: null,
                Allergens: null
            },
            image: '/assets/images/fake_menu_2.jpg'
        },
        {
            data: {
                ID: 0,
                Name: 'Launch menu',
                StartTime: '9',
                EndTime: '3',
                StartDate: new Date(2019, 8, 20),
                EndDate: null,
                DaysOfWeek: 126,
                ImageID: null,
                DisplayInApp: true,
                CreateDateUTC: new Date(2019, 8, 20),
                Places: [
                    {
                        ID: null,
                        Name: 'Honeyland Rivers',
                        Town: '...',
                        PostCode: '',
                        AddressLine1: '155 Victoria street',
                        AddressLine2: ''
                    }
                ],
                FoodPreferences: null,
                Allergens: null
            },
            image: '/assets/images/fake_menu_1.jpg'
        }
    ];
    public businessTypes = this.definitionsService.businessTypes;
    private isArchived = false;
    private waiting = false;
    private data: IMenuListItem[] = [];

    constructor(
        private $rootScope: IRetailerRootScope,
        private $localStorage: ngStorage.StorageService,
        private $scope: ng.IScope,
        private $stateParams: StateParams,
        private menuService: MenuService,
        public definitionsService: DefinitionsService,
        private notificationService: NotificationService
    ) {
        super($rootScope);
        this.isArchived = decodeURIComponent($stateParams.archived) === 'true';

        $scope.$watchGroup(['vm.isArchived'], (n: any, o: any) => {
            this.getData();
        });
        $scope.$on('updateData', () => this.getData());
    }

    private async getData() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            this.data = await this.menuService.getMenus(this.isArchived);
            this.notificationService.clearAll();
            if (this.data.length === 0) {
                this.notificationService.showInfoMessage(null);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }
}

angular.module('naut').component('menus', {
    template: require('./menus.html'),
    controller: MenusController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/components/menus/menus.component.ts